module.exports = __webpack_public_path__ + "assets/img/discernment_pass_check_describe.05ef4dfe.png";